module.exports = __webpack_public_path__ + "img/6_23.44edf19b.png";